module.exports = __webpack_public_path__ + "img/AudiR8300x300.de1e2556.jpg";